/**
 * Asynchronously loads the component for ForbiddenPage
 */
import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
})
